import { render, staticRenderFns } from "./WhitelistCategories.vue?vue&type=template&id=0c609719"
import script from "./WhitelistCategories.vue?vue&type=script&lang=js"
export * from "./WhitelistCategories.vue?vue&type=script&lang=js"
import style0 from "./WhitelistCategories.vue?vue&type=style&index=0&id=0c609719&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports